const doc = [({"da":({"js":({"admin":({"team_surveys":({"show":({"user_step":({"points":"Point", "time":"Tid"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;